import { render, staticRenderFns } from "./TableApplication.vue?vue&type=template&id=23a76812&scoped=true&"
import script from "./TableApplication.vue?vue&type=script&lang=js&"
export * from "./TableApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a76812",
  null
  
)

export default component.exports